import 'react-app-polyfill/stable';
import 'abortcontroller-polyfill';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/_bootstrap-shim.scss';
import 'datalist-css/dist/datalist-css.min.js'
import './index.css';
import { App } from './App';
import { store } from './app/store';
import ErrorBoundary from './errorBoundary'
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import process from "process";
import { Buffer } from "buffer";

window.process = process;
window.Buffer = Buffer;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ToastContainer
    containerId={'warning'}
    position="top-right"
    autoClose={5000}
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
    />
    <Provider store={store}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </Provider>
  </React.StrictMode>
);
